import { ConfigMap } from "../interfaces/configmap";
import { CategorizationAnnotation } from "../interfaces/category";

export const getCategorizationAnnotationForEntityAnnotation = (
  configMap: ConfigMap | undefined,
  entityId: string,
  index: number,
  categorizationAnnotations: Array<CategorizationAnnotation>,
): string | undefined => {
  if (!configMap) {
    return undefined;
  }

  // Find categorization links for this entity type
  const entityCategorizationLinks: string[] = [];
  for (const groupBlock of configMap.groupBlocks || []) {
    for (const gbet of groupBlock.groupBlockEntityTypes || []) {
      if (gbet.entityType.id === entityId) {
        const linkIds =
          gbet.entityType.categorizationLinks?.map(
            (link) => link.categorization.id,
          ) || [];
        entityCategorizationLinks.push(...linkIds);
      }
    }
  }

  if (!entityCategorizationLinks.length) {
    return undefined;
  }

  // Find the first matching categorization annotation
  const foundAnnotation = categorizationAnnotations?.find(
    (ca) =>
      entityCategorizationLinks.includes(ca.categorizationId) &&
      ca.index === index,
  );

  return foundAnnotation?.value;
};

export const getCategorizationIdsForEntityType = (
  configMap: ConfigMap | undefined,
  entityId: string,
): string[] => {
  if (!configMap) {
    return [];
  }

  const categorizationIds: string[] = [];
  for (const groupBlock of configMap.groupBlocks || []) {
    for (const gbet of groupBlock.groupBlockEntityTypes || []) {
      if (gbet.entityType.id === entityId) {
        const linkIds =
          gbet.entityType.categorizationLinks?.map(
            (link) => link.categorization.id,
          ) || [];
        categorizationIds.push(...linkIds);
      }
    }
  }

  return categorizationIds;
};
